module.exports = __webpack_public_path__ + "img/cover-desktop.8d1b5174.jpg";